import React, { useEffect, useRef, useState } from "react";
import { useSupportStore } from "../../store/supportStore.js";
import { Link } from "react-router-dom";
import { Table, ConfigProvider, Input, DatePicker } from "antd";
import moment from "moment";


import images from "../../assets";

const { RangePicker } = DatePicker;

export default function UserFeedback() {
  const { support, isSupportLoading, getSupport } = useSupportStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    fetchSupport();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [support, searchText, dateRange]);

  const fetchSupport = async () => {
    getSupport({});
  };

  const applyFilters = () => {
    let filtered = support;

    if (searchText) {
      filtered = filtered?.filter(
        (item) =>
          item?.subject?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.description
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.firstName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.lastName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.email?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    if (dateRange?.length === 2) {
      const [startDate, endDate] = dateRange;
      filtered = filtered?.filter((item) => {
        const createdAt = moment(item?.createdAt);
        return createdAt?.isBetween(startDate, endDate, "days", "[]");
      });
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "ID",
      width: 70,
      render: (text, record) => record?.id,
      key: "1",
    },
    {
      title: "Name",
      width: 120,
      render: (text, record) => `${record?.firstName} ${record?.lastName}`,
      key: "2",
    },
    {
      title: "Email",
      key: "3",
      width: 130,
      render: (text, record) => record?.email,
    },
    {
      title: "Phone Number",
      key: "3",
      width: 130,
      render: (text, record) => record?.phone,
    },
    {
      title: "Subject",
      key: "11",
      width: 130,
      render: (text, record) => record?.subject,
    },
    {
      title: "Description",
      key: "4",
      render: (text, record) => record?.description,
      width: 250,
    },
    {
      title: "Type",
      key: "6",
      render: (text, record) => record?.type,
      width: 100,
    },
    {
      title: "Created at",
      key: "10",
      render: (text, record) => moment(record?.createdAt).format("DD.MM.YYYY"),
      width: 130,
    },
    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          <Link to={`mailto:${record?.email}`}>
            <img src={images.emailBtn} alt="" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="blog"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <div className="flex flex-col gap-2 w-full">
          <div>Date range</div>
          <RangePicker
            style={{ height: 48 }}
            className="blog"
            onChange={handleDateChange}
            allowClear
          />
        </div>
      </div>
      <div>
        Total pages: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isSupportLoading}
          rowKey={(record) => record?.id}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}









